import { z } from "zod";

export const CLOCK_DRIFT_PATH = "/api/clock-drift";

export const clientClockSchema = z.object({
  clientTime: z.number(),
});

const MAX_ACCEPTABLE_DRIFT_MS = 60_000;

interface ClockDriftWarningInput {
  clientTime: number;
  serverTime: number;
  userId: string;
}

export function getClockDriftWarning({
  clientTime,
  serverTime,
  userId,
}: ClockDriftWarningInput): string | null {
  const driftMs = clientTime - serverTime;
  if (Math.abs(driftMs) <= MAX_ACCEPTABLE_DRIFT_MS) {
    return null;
  }

  const driftSeconds = Math.round(driftMs / 1000);
  return `Clock drift detected for user ${userId}: their device clock is ${Math.abs(
    driftSeconds,
  )}s ${driftSeconds > 0 ? "ahead of" : "behind"} the server. Signed-in sessions may expire early or requests may be rejected.`;
}

export function reportClientClock(): Promise<unknown> {
  return fetch(
    `${process.env.NEXT_PUBLIC_BASE_PATH ?? ""}${CLOCK_DRIFT_PATH}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clientTime: Date.now() }),
    },
  );
}
